import React from 'react'
import {useTranslation} from "react-i18next";
import styled from 'styled-components'
import InformationalIcon from '../assets/images/icons/informational@2x.png'
import LowIcon from '../assets/images/icons/low@2x.png'
import MediumIcon from '../assets/images/icons/medium@2x.png'
import HighIcon from '../assets/images/icons/high@2x.png'
import CriticalIcon from '../assets/images/icons/critical@2x.png'

const Container = styled.div`
    display: inline-block;
    align-items: center;
    min-width:95px;
`

const AlertIcon = styled.img`
  width: 14px;
  height: 14px;
  position: relative;
  top: -2px;
`

const AlertLabel = styled.span`
  color: ${({color = '#999999'}) => color};
  font-size: 12px;
`

/**
 * AlertTag
 * @param type {0 | 1 | 2 | 3 | 4}
 * @param height {number | null}
 * @param space {number | null}
 * @returns {JSX.Element}
 * @constructor
 */
export const AlertTag = ({type = 0, height = 22, space = 10}) => {
    const { t } = useTranslation();

    const labels = [t('alertTag.informational'), t('alertTag.low'), t('alertTag.medium'), t('alertTag.high'), t('alertTag.critical')]
    const colors = ['#999999', '#72AC33', '#E6B05F', '#ED722E', '#C1433C']
    const icons = [InformationalIcon, LowIcon, MediumIcon, HighIcon, CriticalIcon]
    return (
        <Container style={{height}}>
            <AlertIcon src={icons[type-1]} />
            <AlertLabel style={{marginLeft: space}} color={colors[type-1]}>{labels[type-1]}</AlertLabel>
        </Container>
    )
}
